<template>
    <v-dialog v-model="show" no-click-animation persistent width="500">
        <v-card>
            <v-layout class="headline grey lighten-2 pl-3 pr-2 py-2" primary-title align-center>
                <div>{{item ? $t('creator.entity') : $t('editor.entity')}}</div>
                <v-spacer></v-spacer>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-layout>
            <v-card-text>
                <v-form v-model="formValid" @submit="submit" ref="form">
                    <v-text-field
                        :label="$t('words') | capitalize"
                        v-model="word"
                        :rules="formRules.required"
                    ></v-text-field>
                    <v-text-field
                        :label="$t('replacement') | capitalize"
                        v-model="meaning"
                    ></v-text-field>
                    <v-layout wrap class="synonym-container">
                        <v-layout align-center v-for="(synonym, i) in meaningList" :key="i" class="synonym">
                            {{synonym}}
                            <v-icon small @click="removeMeaning(i)">mdi-close</v-icon>
                        </v-layout>
                    </v-layout>
                    <v-layout>
                        <v-spacer></v-spacer>
                        <v-btn class="ma-0" type="submit">{{ $t('save') }}</v-btn>
                    </v-layout>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from "@/modules/fptai/mixins/DialogPromiseFormMixin";
import NLP_Service from "@/services/nlp.service";
import lodash from "lodash";

export default {
    name: "DictionaryEditor",
    mixins: [DialogPromiseFormMixin],
    data () {
        return {
            item: null,
            word: '',
            meaning: '',
            meaningList: []
        }
    },
    methods: {
        open (item) {
            this.item = item
            if (this.item) {
                this.word = item.word
                this.meaning = ''
                this.meaningList = [...item.meaning]
            } else {
                this.clearForm()
                this.meaningList = []
            }
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = { resolve, reject }
            })
        },
        submitValidForm () {
            let model, promise, i18n
            let meaningList = this.meaning
                .split(';')
                .filter(item => !!item)
                .map(item => item.trim())
                .concat(this.meaningList)
            meaningList = lodash.uniqBy(meaningList, item => item)
            model = {
                word: this.word,
                meaning: JSON.stringify(meaningList)
            }
            if (this.item) {
                i18n = {
                    action: this.$t('update'),
                    item: this.$t('dictionary')
                }
                this.$appService.showLoading()
                promise = NLP_Service.DictionaryService.replace(this.$route.params.scenarioId, this.item.code, model)
            } else {
                i18n = {
                    action: this.$t('create'),
                    item: this.$t('dictionary')
                }
                promise = NLP_Service.DictionaryService.create(this.$route.params.scenarioId, model)
            }
            this.$appService.showLoading()
            promise.then(
                result => {
                    this.close()
                    this.$appService.handleRequestError(this.$t('actionSuccessful', i18n))
                    this.promise.resolve(result.data)
                },
                this.$appService.handleRequestError(this.$t('actionFailed', i18n))
            ).finally(this.$appService.hideLoading)
            this.clearForm()
        },
        removeMeaning(index) {
            this.meaningList.splice(index, 1)
        }
    }
}
</script>

<style scoped lang="scss">
    .synonym-container {
        .synonym {
            background: blue;
            color: #fff;
            border-radius: 5px;
            padding: 5px;
            margin: 0 5px 5px 0;
            flex-grow: 0;

            &::v-deep i {
                background: #fff;
                margin-left: 5px;
                border-radius: 100%;
            }
        }
    }
</style>
